const isProduction =
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_ENV === 'production'

export const apiKey = () => {
  return isProduction
    ? process.env.LINX_API_KEY
    : process.env.LINX_API_KEY_STAGE
}

export const origin = () => {
  return isProduction
    ? 'https://www.gazin.com.br'
    : 'https://staging.gazin.com.br'
}

export const removeSkuPrefix = (sku) => sku?.replace('S-', '')
export const AVAILABLE = 'AVAILABLE'
